import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import {
  NbDialogService,
  NbMediaBreakpointsService,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
} from "@nebular/theme";

import { find, remove, clone } from "lodash";

import { Router } from "@angular/router";
import { SupplierService } from "../../../services/supplier.service";

import { Supplier } from "../../../models/supplier.model";
import { History } from "../../../models/history.model";
import { DialogYesNoPromptComponent } from "../../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogSupplierComponent } from "../../dialog-supplier/dialog-supplier.component";
import { DialogHistoryComponent } from "../../dialog-history/dialog-history.component";
import { UserService } from "../../../@core/services/user.service";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ShopService } from "../../../services/shop.service";
import { DialogDeptSupplierArchiveComponent } from "../../dialogs/dialog-dept-supplier-archive/dialog-dept-supplier-archive.component";
import { User } from "../../../@core/data/users";

@Component({
  selector: "ngx-view-supplier",
  styleUrls: ["./view-supplier.component.scss"],
  templateUrl: "./view-supplier.component.html",
})
export class ViewSupplierComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() mode?: string = ""; //home / supplier/dept
  @Input() supplier: Supplier;
  @Input() isMore? = false;
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  user: User;
  loading = false;
  submitted = false;
  view = "main";
  uid = "";
  isMobile = false;
  menuItems: NbMenuItem[] = [
    { title: "Chi tiết", icon: "external-link-outline" },
  ];

  constructor(
    public userService: UserService,
    public shopService: ShopService,
    private supplierService: SupplierService,
    private dialogService: NbDialogService,
    private router: Router,
    private breakpointService: NbMediaBreakpointsService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService,
  ) {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }
        } else {
          this.uid = "anonymous";
        }
      });

    const { sm } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < sm),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanSm: boolean) => {
        this.isMobile = isLessThanSm;
      });
  }

  ngOnInit() {
    this.nbMenuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === `action-buttons-${this.supplier.id}`),
        map(({ item }) => item),
        takeUntil(this.destroy$),
      )
      .subscribe((item) => {
        switch (item.title) {
          case "Sửa":
            this.edit(item.data);
            break;
          case "Xóa":
            this.delete(item.data.id);
            break;
          case "Chi tiết":
            break;
          default:
            break;
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadContent(value) {
    this.isMore = value;
  }

  loadButtonAction(item) {
    this.menuItems = [
      { title: "Sửa", icon: "edit-2-outline", data: item },
      { title: "Xóa", icon: "trash-2-outline", data: { id: item.id } },
      {
        title: "Chi tiết",
        icon: "external-link-outline",
        link: `/supplier/${this.supplier.id}`,
      },
    ];
  }

  navigateRef(item) {
    if (item.navigateUrl != "") {
      this.router.navigateByUrl(item.navigateUrl);
    }
  }

  archiveData() {
    this.dialogService
      .open(DialogDeptSupplierArchiveComponent, {
        context: {
          shopId: this.shopService.shop.shopIdArchived,
          uid: this.uid,
          user: this.user,
          shop: this.shopService.shop,
          supplierId: this.supplier.archivedId ? this.supplier.archivedId : "",
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Supplier) => {
        if (value) {
          console.log(
            "🚀 ~ ViewCustomerComponent ~ .onClose.subscribe ~ value:",
            value,
          );
        }
      });
  }

  delete(item) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nội dung này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.supplierService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.onDelete.emit(item.id);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  edit(item: Supplier) {
    let lecBk = new Supplier();
    lecBk = clone(item);
    this.dialogService
      .open(DialogSupplierComponent, {
        context: {
          header: "Cập nhật bài viết",
          mode: "edit",
          shopId: this.shopId,
          supplier: lecBk,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          item = value;
          this.supplier = value;
          this.onEdit.emit(value);
        }
      });
  }

  createHistory(item: Supplier) {
    //
  }

  createReceipt(item: Supplier) {
    // let lecNew = new History();
    // lecNew.supplierId = item.id;
    // lecNew.fullName = item.fullName;
    // lecNew.dobYear = item.dobYear;
    // lecNew.issueDate = new Date();
    // this.dialogService
    //   .open(DialogHistoryComponent, {
    //     context: {
    //       header: "Tạo trạng thái",
    //       mode: "new",
    //       history: lecNew,
    //     },
    //     closeOnBackdropClick: false,
    //   })
    //   .onClose.subscribe((value) => {
    //     if (value) {
    //     }
    //   });
  }

  viewHistory(item) {
    this.router.navigateByUrl("/supplier/" + item.id);
  }
}
